module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(!_vm.single) ? [_c('div', {
    staticClass: "is-relative"
  }, [_c('h3', {
    staticClass: "stepper__content__header"
  }, [_vm._v(_vm._s(_vm.$t('ADDRESS_DATA')))])]), _vm._v(" "), _c('steps', {
    staticClass: "text-xs-center mb-4",
    attrs: {
      "activeStep": 2,
      "steps": 2
    }
  })] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content__wrapper"
  }, [_c('div', {
    staticClass: "d-flex align-center mb-5"
  }, [_c('h4', {
    staticClass: "stepper__content__title with-description"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('GIVE_ADDRESS_DATA')) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "description box-shadow box-shadow--arrow-left"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('MEDICAL_CARD_INFO')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row row mt-5 mb-3"
  }, [_c('div', {
    staticClass: "log-reg-form--register validation-fields-container",
    attrs: {
      "novalidate": "",
      "spellcheck": "false"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.street),
      expression: "address.street"
    }],
    staticClass: "text-input -white-input-border",
    attrs: {
      "name": "street",
      "placeholder": _vm.$t('STREET'),
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.address.street)
    },
    on: {
      "keyup": _vm.inputKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "street", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-sm-offset-1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.buildingNumber),
      expression: "address.buildingNumber"
    }],
    staticClass: "text-input -white-input-border",
    attrs: {
      "name": "buildingNumber",
      "placeholder": _vm.$t('BUILDING_NR'),
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.address.buildingNumber)
    },
    on: {
      "keyup": _vm.inputKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "buildingNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.flatNumber),
      expression: "address.flatNumber"
    }],
    staticClass: "text-input -white-input-border",
    attrs: {
      "name": "flatNumber",
      "placeholder": _vm.$t('LOCAL_NR'),
      "type": "text"
    },
    domProps: {
      "value": (_vm.address.flatNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "flatNumber", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.city),
      expression: "address.city"
    }],
    staticClass: "text-input -white-input-border",
    attrs: {
      "id": "",
      "name": "city",
      "placeholder": _vm.$t('CITY'),
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.address.city)
    },
    on: {
      "keyup": _vm.inputKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-sm-offset-1"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.zipCode),
      expression: "address.zipCode"
    }],
    staticClass: "text-input -white-input-border",
    attrs: {
      "name": "zipCode",
      "placeholder": _vm.$t('POSTAL_CODE'),
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.address.zipCode)
    },
    on: {
      "keyup": _vm.inputKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "zipCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-select', {
    staticClass: "text-input -white-input-border",
    class: {
      'invalid-date': _vm.address.countryCode === '' && _vm.formSubmitted
    },
    attrs: {
      "filterable": "",
      "placeholder": _vm.$t('COUNTRY'),
      "filter-method": _vm.filterOptions
    },
    model: {
      value: (_vm.address.countryCode),
      callback: function($$v) {
        _vm.$set(_vm.address, "countryCode", $$v)
      },
      expression: "address.countryCode"
    }
  }, _vm._l((_vm.filteredCountries), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": ((item.name) + " (" + (item.nativeName) + ")"),
        "value": item.code
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('button', {
    staticClass: "buttons-container__button validate-test validate-button hidden",
    attrs: {
      "id": "formBtn"
    }
  })])]), _vm._v(" "), (_vm.address.countryCode === 'IE') ? _c('label', {
    staticClass: "checkbox -checkbox-long",
    staticStyle: {
      "max-width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.irelandAgreement),
      expression: "address.irelandAgreement"
    }],
    staticClass: "checkbox__check-input",
    attrs: {
      "required": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.address.irelandAgreement) ? _vm._i(_vm.address.irelandAgreement, null) > -1 : (_vm.address.irelandAgreement)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.address.irelandAgreement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.address, "irelandAgreement", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.address, "irelandAgreement", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.address, "irelandAgreement", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox__check -grey-border-checkbox"
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox__text -black-checkbox-text",
    staticStyle: {
      "font-size": "14px",
      "font-weight": "400"
    }
  }, [_vm._v("\n                I have read and understand the information made available by the service provider Braster S.A.\n                regarding the rendering of services with the use of telemedicine. All of my questions have been\n                answered to my satisfaction. I hereby give my informed consent for the use of telemedicine for the\n                purpose of rendering the thermographic tests by the service provider.\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.single) ? _c('div', [_c('button', {
    staticClass: "w160 mr-3 app-btn app-btn--small app-btn-default mt-3",
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('CANCEL')) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "w160 mr-3 app-btn app-btn--small app-btn-primary mt-3",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('SAVE')) + "\n                ")])]) : _c('div', [_c('button', {
    staticClass: "w160 mr-3 app-btn app-btn--small app-btn-default mt-3",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('PREVIOUS')) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "w160 mr-3 app-btn app-btn--small app-btn-primary mt-3",
    on: {
      "click": _vm.goNext
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('NEXT')) + "\n                ")])])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60d6066e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/main-survey/survey-step5-q2.vue
// module id = 1212
// module chunks = 0